<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="danger" v-b-tooltip.hover :title="showToolTip ? 'Отвязать' : ''"><i class="fa fa-unlink"></i></b-button>
</template>

<script>

export default ({
  name: "button-unlink",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
